import { render, staticRenderFns } from "./SystemVariable.vue?vue&type=template&id=64452989"
import script from "./SystemVariable.vue?vue&type=script&lang=js"
export * from "./SystemVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports